<div class="container-fluid botFix">
  <div class="row btnPosFixTop">
    <div class="col-xl-4 col-lg-4 col-sm-6 col-xs-12" >
      <certificate-upload></certificate-upload>
    </div>
    <div class="col-xl-4 col-lg-4 col-sm-6 col-xs-12"> 
      <image-upload></image-upload>
    </div>
  </div>
</div>